import { render, staticRenderFns } from "./QuoteDetailForm.vue?vue&type=template&id=1a82b9d6&"
import script from "./QuoteDetailForm.vue?vue&type=script&lang=ts&"
export * from "./QuoteDetailForm.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteDetailForm.vue?vue&type=style&index=0&id=1a82b9d6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports